import { Card, CardContent, Grid, Skeleton, Typography, useMediaQuery } from "@mui/material";
import type { ReactNode } from "react";
import { rangeUtil } from "utils/rangeUtil";

function CommandeCardSkeleton(): ReactNode {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Card variant="outlined">
      <CardContent>
        <Grid container spacing={2} size={12}>
          <Grid container spacing={3} size={12} sx={{ alignItems: "center" }}>
            <Grid size="auto">
              <Skeleton animation="wave" variant="rounded" height={50} width={50} />
            </Grid>
            <Grid size="grow">
              <Typography variant={isSmallScreen ? "body1" : "subtitle2"}>
                <Skeleton animation="wave" />
              </Typography>
              <Skeleton animation="wave" width={100} />
            </Grid>
          </Grid>
          {rangeUtil.arrayRange(5).map((i) => (
            <Grid key={i} size={12}>
              <Skeleton animation="wave" />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
}

export default CommandeCardSkeleton;
